import { useDispatch, useSelector } from 'react-redux';
import { clearCache } from '../../store/opsSlice';
import Loading from '../common/Loading';
import { Button } from '../ui/button';
import { Card } from '../ui/card';

const CacheCard = ({dispatch, loading = false}) => {
    const clearCacheFunc = () => dispatch(clearCache());
    return (
        <Card className="border border-border bg-card rounded-2xl p-6 shadow-sm">
            <div className="flex items-start justify-between mb-2">
                <span className="text-sm text-muted-foreground font-medium">Cache Management</span>
            </div>
            <div className="text-4xl font-bold text-foreground mb-6">
                {loading ? (
                    <Loading />
                ) : (
                    <Button 
                        variant="default" 
                        size="default"
                        onClick={clearCacheFunc}
                        className="h-9 px-4"
                    >
                        Clear Backend Cache
                    </Button>
                )}
            </div>
            <div className="mt-2">
                <div className="text-sm text-muted-foreground">
                    Clear the backend cache to refresh system data
                </div>
            </div>
        </Card>
    );
};

export default function System() {
    let {
        loading
    } = useSelector( state => state.ops );

    let dispatch = useDispatch();

    return (
        <div className="flex flex-1 flex-col gap-4 p-4 md:gap-8 md:p-6">

            <div className="grid gap-4 md:grid-cols-3 lg:grid-cols-3">
                <CacheCard loading={loading} dispatch={dispatch}/>
            </div> 
        </div>
    );
}